module.exports = class InternalCtrl {
  constructor($stateParams) {
    this.$stateParams = $stateParams;
  }
};
